import { AxiosError } from 'axios';
import instance from '../config/axios';
import { ContactDetails } from '../interface/interface';

export const submitContactUsForm = async (
  accessToken: string,
  details: ContactDetails,
) => {
  try {
    const response = await instance({
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      data: { details },
      method: 'POST',
      url: `api/v1/patient/submit/contact-us`,
    });

    return response.status;
  } catch (e) {
    console.log('Error while retriving doctors', e);
    return (e as AxiosError).response?.status;
  }
};
